import { render, staticRenderFns } from "./transactions-list.vue?vue&type=template&id=a349cafe"
import script from "./transactions-list.vue?vue&type=script&lang=js"
export * from "./transactions-list.vue?vue&type=script&lang=js"
import style0 from "./transactions-list.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/transactions-list.vue
// module id = TRrC
// module chunks = 0